define('app/dashboard/widgets/DonutChartDashboardItemView',['require','./ReportDashboardItemView','app/visualizations/SimpleCategoricalChartView','app/visualizations/FormatFactory','app/app','glu/util','hbs!./DonutChartDashboardItemView.hbs'],function(require) {

	'use strict';

	var ReportDashboardItemView = require('./ReportDashboardItemView'),
		SimpleCategoricalChartView = require('app/visualizations/SimpleCategoricalChartView'),
		FormatFactory = require('app/visualizations/FormatFactory'),
		APP = require('app/app'),
		_ = require('glu/util');

	var WidgetDonutChart = SimpleCategoricalChartView.extend({
		type: 'donut',

		getChartData: function(results) {
			var report = this.options.model,
				donutFilterValues = report.getOption('donutFilterValues') ? JSON.parse(report.getOption('donutFilterValues')) : {},
				selectedColumn = report.getOption('selectedColumn'),
				selectedRow,
				donutData = results.donutData(),
				selectedValue,
				selectedAggregation;

			// Remove '_AGGREGATION'
			if (selectedColumn) {
				selectedColumn = selectedColumn.split('_');
				selectedAggregation = selectedColumn[selectedColumn.length - 1];
				selectedColumn = selectedColumn.join('_');
				selectedRow = _.findWhere(donutData, donutFilterValues);
				selectedValue = selectedRow && selectedColumn ? selectedRow[selectedColumn] : 0;

				this.setSelectedColumn(results.unformattedData().header, selectedColumn, selectedAggregation);
				this.model.setOption('selectedVal', selectedValue, {
					silent: true
				});

				return selectedValue;
			} else {
				return null;
			}
		},

		setSelectedColumn: function(columns, selected, aggregation) {
			// remove 'column_'
			selected = selected.split('_');
			selected.shift();

			// check for function elapsed time
			var selectedColumn,
				name = '',
				id = '',
				type = '',
				total = 0,
				isPercentage = false;


			if (selected[0] === 'elapsedtime') {
				for (var i = 0; i < columns.length; i++) {
					var c = columns[i];
					if (c.columnType === 'FUNCTION') {
						var fields = _.pluck(c.funcArguments, 'fieldId').join('_');
						selected = selected.slice(1, -1).join('_');
						if (fields === selected && aggregation === c.aggregation) {
							selectedColumn = c;
						}
					}
				}
			} else {
				selected = selected.slice(0, -1).join('_');
				selectedColumn = _.findWhere(columns, {
					fieldId: selected,
					aggregation: aggregation
				});
			}

			if (selectedColumn) {
				name = selectedColumn.asName || selectedColumn.name;
				id = selectedColumn.id;
				type = selectedColumn.fieldType;
				total = selectedColumn.total;
				isPercentage = selectedColumn.isPercentage;
			}

			this.model.setOption('selectedName', name, {
				silent: true
			});
			this.model.setOption('selectedId', id, {
				silent: true
			});
			this.model.setOption('selectedColType', type, {
				silent: true
			});
			this.model.setOption('selectedColTotal', total, {
				silent: true
			});
			this.model.setOption('selectedColAggregation', aggregation, {
				silent: true
			});
			this.model.setOption('selectedColIsPercentage', isPercentage, {
				silent: true
			});
		},

		getChartOptions: function() {
			var self = this,
				report = this.options.model,
				color1, color2,
				height,
				width,
				donutWidth,
				dashboard = APP.dashboards.find(function(d) {
					return d.id === report.get('dashboardId');
				});

			if (dashboard.get('layout') === 'DECISION') {
				switch (report.get('name')) {
					case 'Total Requests':
					case 'Submitted Applications':
						self.$el.addClass('neutral');
						width = 105;
						height = 105;
						donutWidth = 13;
						color1 = '#cccccc';
						color2 = '#cccccc';
						break;
					case 'Completed Requests':
					case 'Commenced Applications':
						self.$el.addClass('positive');
						width = 105;
						height = 105;
						donutWidth = 13;
						color1 = '#8fb667';
						color2 = '#cccccc';
						break;
					case 'Auto-Declined':
					case 'KBA Declined':
					case 'Manually Declined':
					case 'Canceled Applications':
						self.$el.addClass('negative');
						width = 155;
						height = 155;
						donutWidth = 20;
						color1 = '#a4494e';
						color2 = '#cccccc';
						break;
					default:
						width = 155;
						height = 155;
						donutWidth = 20;
						color1 = '#5591B1';
						color2 = '#cccccc';
				}
			} else if (dashboard.get('layout') === 'CONVERSION') {
				width = 105;
				height = 105;
				donutWidth = 13;

				switch (report.get('name')) {
					/* Neutral */
					case 'Visits':
					case 'Total Applicants':
					case 'Applications Started':
					case 'Requests Started':
						self.$el.addClass('neutral');
						color1 = '#cccccc';
						color2 = '#cccccc';
						break;
						/* Positive */
					case 'Conversion':
					case 'Completed':
					case 'Commenced':
						self.$el.addClass('positive');
						color1 = '#8fb667';
						color2 = '#cccccc';
						break;
						/* Negative */
					case 'Declined Requests':
						self.$el.addClass('negative');
						color1 = '#97030a';
						color2 = '#cccccc';
						break;
					default:
						color1 = '#5591B1';
						color2 = '#cccccc';
				}
			} else if (dashboard.get('layout') === 'MARKETING') {
				width = 155;
				height = 155;
				donutWidth = 20;
				color1 = '#5591B1';
				color2 = '#cccccc';

				switch (report.get('name')) {
					case 'Requests Started':
						self.$el.addClass('legacy-kpi');
						self.$el.addClass('positive');
						break;
					case 'Joint Applicant Requests':
						self.$el.addClass('tertiary');
						color1 = '#ac6d9a';
						break;
					case 'Existing Customers':
						self.$el.addClass('quaternary');
						color1 = '#3e807e';
						break;
					case 'Requests Submitted':
						self.$el.addClass('positive');
						color1 = '#8fb667';
						break;
				}
			} else {
				width = 110;
				height = 110;
				donutWidth = 14;
				color1 = '#5591B1';
				color2 = '#cccccc';
			}

			return {
				c3: {
					data: {
						columns: [
							['Val', self.getPercentageOfTotal()],
							['Total', 100 - self.getPercentageOfTotal()]
						],
						type: 'donut',
						order: null
					},
					interaction: {
						enabled: false
					},
					color: {
						pattern: [color1, color2]
					},
					donut: {
						label: {
							show: false
						},
						width: donutWidth
					},
					size: {
						width: width,
						height: height
					},
					legend: {
						show: false,
						hide: true
					},
					grid: {
						x: {
							show: false
						},
						y: {
							show: false
						}
					},
					axis: {
						x: {
							shown: false
						},
						y: {
							shown: false
						}
					},
					padding: {
						top: 0,
						right: 0,
						bottom: 0,
						left: 0
					}
				}
			};
		},

		renderChart: function(chart) {
			var self = this,
				name = this.model.getOption('selectedName'),
				value = this.model.getOption('selectedVal') || 0,
				type = this.model.getOption('selectedColType'),
				aggregation = this.model.getOption('selectedColAggregation'),
				isPercentage = this.model.getOption('selectedColIsPercentage'),
				domainId = this.model.get('domainId'),
				reportId = this.model.get('id'),
				formatOptions = {
					aggregation: aggregation
				};

			chart.setElement(this.el);
			chart.$el.addClass('donut-chart-widget-wrap');
			chart.$el.hide();

			if (isPercentage) {
				chart.$el.addClass('percentage');
			}

			// If we aren't on a custom dashboard, and it makes sense to show a donut chart
			if (this.model.get('results').rows.length === 1 || aggregation === 'MEDIAN' || aggregation === 'STDDEV' || aggregation === 'AVG') {
				chart.render();
				chart.$el.addClass('legacy-kpi');
				chart.$el.append('<div class="name"><a href="/domains/' + domainId + '/reports/' + reportId + '/filtered">' + name + '</a></div>' +
					'<div class="value"><a href="/domains/' + domainId + '/reports/' + reportId + '/filtered">' + FormatFactory.formatterForType(type, formatOptions)(value) + '</a></div>');

				window.setTimeout(function() {
					if (chart.$el.find('.value a').length > 0) {
						var chartWidth = 250;
						var textWidth = chart.$el.find('.value a')[0].offsetWidth;
						var zoom = chartWidth / textWidth > 1.2 ? 1.2 : chartWidth / textWidth;
						if (chartWidth) {
							var css = {
								'transform': 'scale(' + zoom + ')',
								'-ms-transform': 'scale(' + zoom + ')',
								'-moz-transform': 'scale(' + zoom + ')',
								'-webkit-transform': 'scale(' + zoom + ')'
							};
							chart.$el.find('.value a').css(css);
						}
					}
				}, 100);
			} else {
				chart.render();

				chart.$el.append('<div class="percent"><a href="/domains/' + domainId + '/reports/' + reportId + '/filtered">' + self.getPercentageOfTotal() + '<sup>%</sup></a></div>' +
					'<div class="name"><a href="/domains/' + domainId + '/reports/' + reportId + '/filtered">' + name + '</a></div>' +
					'<div class="value"><a href="/domains/' + domainId + '/reports/' + reportId + '/filtered">' + FormatFactory.formatterForType(type, formatOptions)(value) + '</a></div>');
				window.setTimeout(function() {
					if (chart.$el.find('.value a').length > 0) {
						var chartWidth = 250;
						var textWidth = chart.$el.find('.value a')[0].offsetWidth;
						var zoom = chartWidth / textWidth > 1.2 ? 1.2 : chartWidth / textWidth;
						if (chartWidth) {
							var css = {
								'transform': 'scale(' + zoom + ')',
								'-ms-transform': 'scale(' + zoom + ')',
								'-moz-transform': 'scale(' + zoom + ')',
								'-webkit-transform': 'scale(' + zoom + ')'
							};
							chart.$el.find('.value a').css(css);
						}
					}
				}, 100);
			}

			chart.$el.fadeIn();
		},

		getPercentageOfTotal: function() {
			var output = (Math.round((this.model.getOption('selectedVal') / this.model.getOption('selectedColTotal') * 100) * 100) / 100).toFixed(1);

			output = output >= 100 ? 100.0 : output;

			return isNaN(output) ? 0 : output.toString().match(/^-?\d+(?:\.\d{0,1})?/)[0];
		}
	});

	return ReportDashboardItemView.extend({
		className: 'dashboard-item dashboard-item-donut-chart',
		template: require('hbs!./DonutChartDashboardItemView.hbs'),

		initialize: function() {
			// call base class initialize function
			ReportDashboardItemView.prototype.initialize.call(this);

			this.model.set('isLoading', true);
			this.listenTo(this.model, 'dataReceived', this.dataReceived);
			this.listenTo(this.model, 'change', this.render);


			this.model.set('selectedName', 1, {
				silent: true
			});
			this.model.set('selectedId', 1, {
				silent: true
			});
			this.model.set('selectedVal', 1, {
				silent: true
			});
			this.model.set('selectedColType', 1, {
				silent: true
			});
			this.model.set('selectedColTotal', 1, {
				silent: true
			});
			this.model.set('selectedColAggregation', 1, {
				silent: true
			});
		},

		regions: {
			chartContainer: '.donut-chart-container'
		},

		onRender: function() {
			this.chartView = new WidgetDonutChart({
				model: this.model
			});

			this.chartContainer.show(this.chartView);
		},

		dataReceived: function() {
			this.model.set('isLoading', false);
			this.render();
		},

		isLoading: function() {
			return this.model.get('isLoading');
		}
	});
});

